import React from 'react';
import './NewCollectionPage.css';
import '@shopify/polaris/dist/styles.css';
import Collection from '../components/Collection';
import AuthenticatedPage from '../components/AuthenticatedPage';

function NewCollectionPage() {
  return (
    <AuthenticatedPage>
      {shopOrigin => <Collection shopOrigin={shopOrigin} type="new" />}
    </AuthenticatedPage>
  );
}

export default NewCollectionPage;
